import { request } from '@/utils/request';

export function createXiaohongshuAccount(data: API.Xiaohongshu) {
  return request('/local/xiaohongshu', {
    method: 'post',
    data
  })
}

export function updateXiahongshuAccount(data: { data: API.Xiaohongshu, id: string }) {
  return request(`/local/xiaohongshu/${data.id}`, {
    method: 'put',
    data: data.data
  })
}

export function getXiaohongshuAccounts(params: { page: number, size: number, name: string }) {
  return request('/local/xiaohongshu', { params });
}

export function getXiaohongshuDetail(params: { id: string }) {
  return request(`/local/xiaohongshu/${params.id}`);
}

export function formatXiaohongshuConfig(data: { email: string; password: string; words: API.Word[], situations: API.Situation[], commonFollowup: string, approaches: API.Approach[] }) {
  return request(`/local/xiaohongshu/format`, {
    method: 'post',
    data
  })
}

export function createWorker(data: API.XiahongshuWorker) {
  return request('/local/worker', {
    method: 'post',
    data
  })
}

export function getWorkers(params: { page: number; size: number }) {
  return request('/local/worker', { params });
}

export function updateWorker(data: { data: API.XiahongshuWorker, id: string }) {
  return request(`/local/worker/${data.id}`, {
    method: 'put',
    data: data.data
  })
}

export function getWorkerVersionMap() {
  return request('/local/worker/version_map', {});
}

export function initXiaohongshuRobot() {
  return request('/local/xiaohongshu/formatRobotConfig', {});
}

export function initWorker() {
  return request('/local/worker/init', {});
}

export function getWorkflowsByPlatform(params: { platform: number }) {
  return request('/local/workflow/connect/list', { params })
}

export function connectWorkflow(data: { id: number; workflowId?: number, mode: number }) {
  return request('/local/xiaohongshu/connect/workflow', {
    method: 'post',
    data
  })
}

export function setCookiesLocalStorage(data: { name: string, cookies: any[], localStorage: any[] }) {
  request('/local/xiaohongshu/cookies/localStorage/set', {
    method: 'post',
    data
  })
}

export function activate(data: { name: string }) {
  return request('/local/xiaohongshu/user/activate', {
    method: 'post',
    data
  })
}

export function sendCode(data: { name: string, phone: string }) {
  return request('/local/xiaohongshu/home/send/code', {
    method: 'post',
    data
  })
}

export function checkCode(data: { name: string, phone: string, code: string }) {
  return request('/local/xiaohongshu/home/check/code', {
    method: 'post',
    data
  })
}

export function loginPhone(data: { name: string, mobile_token: string, phone: string }) {
  return request('/local/xiaohongshu/home/login/phone', {
    method: 'post',
    data
  })
}

export function getQRCode(data: { name: string }) {
  return request('/local/xiaohongshu/home/qrcode/get', {
    method: 'post',
    data
  })
}

export function checkQRCode(data: { name: string, qr_id: string, code: string }) {
  return request('/local/xiaohongshu/home/qrcode/check', {
    method: 'post',
    data
  })
}

export function checkCaptcha(data: { name: string, mouseEnd: string, time: string, track: string, rid: string, verifyUuid: string }) {
  return request('/local/xiaohongshu/home/captcha/check', {
    method: 'post',
    data
  })
}

export function getXhsCookies(data: { name: string }) {
  return request('/local/xiaohongshu/note/cookie/get', {
    method: 'post',
    data
  })
}

export function getXhsAccountInfo(data: { name: string }) {
  return request('/local/xiaohongshu/user/info/get', {
    method: 'post',
    data
  })
}

export function clearXhsCookies(data: { name: string }) {
  return request('/local/xiaohongshu/note/cookie/clear', {
    method: 'post',
    data
  })
}

export function rewriteNoteTitle(data: { content: string, style: 'mimeng' | 'xhs' }) {
  return request('/local/xiaohongshu/note/title/rewrite', {
    method: 'post',
    data
  })
}

export function publishImageNote(data: {
  name: string,
  title: string,
  content: string,
  files: string[],
  tags: any[],
  ats: any[],
  trailer_plan?: any,
  goods?: any[],
  is_private?: boolean,
  area?: string,
  noteId?: number
}) {
  return request('/local/xiaohongshu/creator/note/create/image', {
    method: 'post',
    data
  })
}

export function publishVideoNote(data: {
  name: string,
  title: string,
  content: string,
  files: string[],
  tags: any[],
  ats: any[],
  trailer_plan?: any,
  goods?: any[],
  is_private?: boolean,
  area?: string,
  noteId?: number
}) {
  return request('/local/xiaohongshu/creator/note/create/video', {
    method: 'post',
    data
  })
}

export function scheduleImageNote(data: {
  name: string,
  title: string,
  content: string,
  files: string[],
  tags: any[],
  ats: any[],
  trailer_plan?: any,
  goods?: any[],
  is_private?: boolean,
  area?: string,
  scheduled_time: string,
  noteId?: number
}) {
  return request('/local/xiaohongshu/creator/note/schedule', {
    method: 'post',
    data
  })
}

export function rewriteNoteContent(data: { content: string, imgs?: string[] }) {
  return request('/local/xiaohongshu/note/content/rewrite', {
    method: 'post',
    data
  })
}

export function adjustNoteContent(data: { content: string, suggestion: string, imgs?: string[] }) {
  return request('/local/xiaohongshu/note/content/adjust', {
    method: 'post',
    data
  })
}

export function adjustTextContent(data: { content: string, suggestion: string, paragraph: string }) {
  return request('/local/xiaohongshu/note/content/adjust/text', {
    method: 'post',
    data
  })
}

export function saveNote(data: { name: string, content?: string, title?: string, imgs?: string[], tags?: string[], noteId?: number, published?: boolean, publishedNoteId?: string, publishedNoteUrl?: string, xsecToken?: string }) {
  if (!data.noteId) {
    return request('/local/xiaohongshu/creator/note/create', {
      method: 'post',
      data
    })
  }
  return request('/local/xiaohongshu/creator/note/update', {
    method: 'post',
    data
  })
}

export function listNotes(data: { name: string, page: number, pageSize: number }) {
  return request('/local/xiaohongshu/creator/note/list', {
    method: 'post',
    data
  })
}

export function getNote(data: { name: string, noteId: number }) {
  return request('/local/xiaohongshu/creator/note/get/db', {
    method: 'post',
    data
  })
}

export function getSxtProcesses(data: {}) {
  return request('/local/xiaohongshu/sxt/robots', {
    method: 'post',
    data
  })
}

export function listAutoReplyTasks(data: { name: string }) {
  return request('/local/xiaohongshu/creator/mention/autoreply/get', {
    method: 'post',
    data
  })
}

export function createAutoReplyTask(data: { name: string, reply: string, noteId: number, replyWith: string, listenerId: string }) {
  return request('/local/xiaohongshu/creator/mention/autoreply/create', {
    method: 'post',
    data
  })
}

export function activateAutoReplyTask(data: { name: string, taskId: number }) {
  return request('/local/xiaohongshu/creator/mention/autoreply/activate', {
    method: 'post',
    data
  })
}

export function deactivateAutoReplyTask(data: { name: string, taskId: number }) {
  return request('/local/xiaohongshu/creator/mention/autoreply/deactivate', {
    method: 'post',
    data
  })
}

export function getNoteByUrl(data: { name: string, url: string }) {
  return request('/local/xiaohongshu/creator/note/get/url', {
    method: 'post',
    data
  })
}

export function startAutoReply(data: { name: string }) {
  return request('/local/xiaohongshu/creator/mention/autoreply/start', {
    method: 'post',
    data
  })
}

export function stopAutoReply(data: { name: string }) {
  return request('/local/xiaohongshu/creator/mention/autoreply/stop', {
    method: 'post',
    data
  })
}

export function getSchedules(data: {}) {
  return request('/local/xiaohongshu/creator/mention/autoreply/schedules', {
    method: 'post',
    data
  })
}

export function muteUser(data: { name: string, user_id: string, type: 'black' | 'grey', nickname?: string }) {
  return request('/local/xiaohongshu/creator/mention/mute/set', {
    method: 'post',
    data
  })
}

export function unmuteUser(data: { name: string, user_id: string, type: 'black' | 'grey', nickname?: string }) {
  return request('/local/xiaohongshu/creator/mention/unmute/set', {
    method: 'post',
    data
  })
}

export function mutedUserGet(data: { name: string, type: 'black' | 'grey' }) {
  return request('/local/xiaohongshu/creator/mention/mute/get', {
    method: 'post',
    data
  })
}

export function addReply(data: { name: string, reply: string }) {
  return request('/local/xiaohongshu/creator/mention/reply/add', {
    method: 'post',
    data
  })
}

export function deleteReply(data: { name: string, reply: string }) {
  return request('/local/xiaohongshu/creator/mention/reply/delete', {
    method: 'post',
    data
  })
}

export function listReplies(data: { name: string }) {
  return request('/local/xiaohongshu/creator/mention/reply/list', {
    method: 'post',
    data
  })
}

export function getTrailerPlan(data: { name: string }) {
  return request('/local/xiaohongshu/livemall/trailer_plan', {
    method: 'post',
    data
  })
}

export function getGoodsInfo(data: { name: string }) {
  return request('/local/xiaohongshu/livemall/goods_info', {
    method: 'post',
    data
  })
}

export function getAtUser(data: { name: string, page: number, keyword: string }) {
  return request('/local/xiaohongshu/creator/note/suggest/ats', {
    method: 'post',
    data
  })
}

export function getSuggestTags(data: { name: string, tag: string }) {
  return request('/local/xiaohongshu/creator/note/suggest/tags', {
    method: 'post',
    data
  })
}

export function getCustomizeTag(data: { name: string, tag: string }) {
  return request('/local/xiaohongshu/creator/note/customize/tag', {
    method: 'post',
    data
  })
}

export function editImage(data: { images: string[], suggestion: string, model: string, dimension?: { width: number, height: number } }) {
  return request('/local/xiaohongshu/note/image/edit', {
    method: 'post',
    data
  })
}

export function generateSoraVideo(data: {
  prompt: string;
  duration?: number;
  size?: 'small' | 'large';
  aspectRatio?: '9:16' | '16:9';
  referenceImage?: string;
  shutProgress?: boolean;
}) {
  return request('/local/ai/xhs/note/video/sora/generate', {
    method: 'post',
    data,
  });
}

export function getSoraVideoStatus(data: { jobId: string }) {
  return request('/local/ai/xhs/note/video/sora/status', {
    method: 'post',
    data,
  });
}

export function uploadLocalImage(data: { file: File }) {
  const formData = new FormData();
  formData.append('file', data.file, data.file.name);

  return request('/local/utils/uploadOSS', {
    method: 'post',
    data: formData
  });
}

export function getCommentDetails(data: { name: string; page?: number; pageSize?: number }) {
  return request('/local/xiaohongshu/comment/details', {
    method: 'post',
    data
  });
}

export function replyToComment(data: { commentId: number; replyContent: string; replyMethod?: 'comment' | 'sxt', listenerId?: string }) {
  return request('/local/xiaohongshu/comment/reply', {
    method: 'post',
    data
  });
}

// 敏感词检测
export async function sensitiveWordCheck(data: {
  content: string;
  profession?: string;
}) {
  return request('/local/xiaohongshu/analysis/sensitive', {
    method: 'POST',
    data,
  });
}

interface NoteSearchParams {
  data: {
    // 基础搜索输入
    input?: {
      keyword?: string;
      type?: Array<'title' | 'topic' | 'content' | 'tag' | 'name' | 'categoryName' | 'seedBrandName'>;
    };

    // 基础信息筛选
    baseInfoRequest?: {
      type?: string;
      createTime?: string;
      contentTags?: string[];
      noteType?: string;
      commentFeature?: string;
    };

    // 高级筛选条件
    high?: {
      isMcn?: string;
      authorGender?: string;
      userAttribute?: string[];

      // 粉丝数范围
      fan?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 点赞收藏数范围
      likedCollectedCountRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 互动数范围
      interactiveCountRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 点赞数范围
      likedCountRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 收藏数范围
      collectedCountRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 评论数范围
      commentsCountRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 分享数范围
      sharedCountRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 预计阅读数范围
      predReadnumRange?: {
        fixedRange?: string;
        customizeRange?: string;
      };

      // 地理位置
      province?: string;
      city?: string;
    };

    // 排序方式
    sort?: 'likedCount' | 'collectedCount' | 'commentsCount' | 'sharedCount' | 'createTime' | 'interactiveCount';

    // 分页参数
    size?: number;
    start?: number;

    // 自定义条件
    custom?: {
      must?: any[];
      should?: any[];
      mustNot?: any[];
    };

    // 数据源
    source?: {
      type?: string;
      keyword?: string;
    };

    // 时间筛选
    time?: '24h' | '7d' | '30d';
    startTime?: string;
    endTime?: string;

    // 其他选项
    filterIncomplete?: number;
  };
}

export async function getNoteStats(data: NoteSearchParams) {
  return request('/local/xiaohongshu/analysis/note/stats', {
    method: 'POST',
    data,
  });
}

export async function getNoteXsecTokenFromUser(data: { name: string, userId: string, noteId: string }) {
  return request('/local/xiaohongshu/analysis/note/xsec_token', {
    method: 'POST',
    data,
  });
}
